<template>
  <ModalBaseNew :isVisible="isVisible"
                title="Finální faktura"
                :saveAllowed="isFormValid"
                @save="saveFinalInvoice"
                @modalStatus="handleModalStatus">
    <div @validation="handleValidation">
      <div class="row my-3">
        <div class="form-group col-3">
          <label class="form-label" for="price">Finální cena vč. DPH</label>
          <input type="number"
                 :min=0
                 class="form-control"
                 id="price"
                 name="price"
                 v-model="finalInvoice.price_final"
                 v-validate="{
                 rules: {
                   required: true,
                 },
                 message: {
                   required: 'Cena je povinná'
                 },
                 options: {showValidState: false}
               }">
        </div>
        <div class="form-group col-3">
          <label for="vat" class="form-label">Sazba DPH:</label>
          <select class="form-select"
                  id="vat"
                  name="vat"
                  v-model="finalInvoice.vat_rate"
                  v-validate="{
                         rules: { required: true },
                         message: { required: 'Sazba DPH je povinná'},
                         options: { showValidState: false }
                       }">
            <option value="-1" disabled>vyber DPH...</option>
            <option v-for="(text, key) in vatOptions" :key="key" :value="key">
              {{ text }}
            </option>
          </select>
        </div>
        <div class="form-group col-3 pb-2">
          <div class="form-check form-switch" style="margin-top: 30px">
            <label class="form-check-label" for="delegatedVat">Přenesená daň</label>
            <input class="form-check-input"
                   type="checkbox"
                   role="switch"
                   id="delegatedVat"
                   v-model="finalInvoice.delegated_vat"
                   name="delegatedVat">
          </div>
        </div>
      </div>
      <div class="row my-3">
        <div class="form-group col-2">
          <label class="form-label" for="due">Splatnost (dny):</label>
          <input type="number"
                 :min=0
                 :max=60
                 class="form-control"
                 id="due"
                 name="due"
                 v-model="finalInvoice.due"
                 v-validate="{
                 rules: {
                   required: true,
                 },
                 message: {
                   required: 'Splatnost je povinná'
                 },
                 options: {showValidState: false}
               }">
        </div>
        <div class="col-md-5">
          <label class="form-label">Typ platby:</label>
          <select
              class="form-select"
              name="payment_method"
              v-model="finalInvoice.payment_method"
          >
            <option v-for="method in paymentMethods" :key="method.value" :value="method.value">
              {{ method.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-12">
          <div class="form-group">
            <label class="form-label" for="invoice-text">
              Text finální faktury:
              <small class="text-muted">({{ finalInvoice.line_text?.length || 0 }}/500)</small>
            </label>
            <textarea
                rows="8"
                class="form-control"
                id="order-text"
                name="order_text"
                maxlength="2000"
                placeholder="Zadejte text uvedený na finální faktuře..."
                v-model="finalInvoice.line_text"
                v-validate="{
                   rules: { required: true},
                   message: { required: 'Text je povinný'},
                   options: { showValidState: true }
                 }"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </ModalBaseNew>
</template>

<script setup>
import ModalBaseNew from "@/components/base/ModalBaseNew.vue";
import {defineEmits, defineProps, ref, defineModel} from "vue"

const finalInvoice = defineModel({
  default: () => ({
    delegated_vat: false,
    due: null,
    payment_method: 'bank',
    vat_rate: 21,
    price_final: null,
    line_text: null
  })
})

const props = defineProps(
    {
      isVisible: {type: Boolean, default: false, required: true}
    }
)

const emit = defineEmits([
  'update:isVisible',
  'invoiceSaved'
]);

const fieldStatus = ref({})
const vatOptions = {0: '0 %', 12: '12 %', 21: '21 %'};
const paymentMethods = ref([
  {value: 'bank', label: 'Bankovní převod'},
  {value: 'cash', label: 'Hotovost - okamžitá platba'},
]);
const isFormValid = ref(false)

const handleValidation = (event) => {
  const {fieldName, isValid} = event.detail;

  // Uložíme stav konkrétního pole
  fieldStatus.value[fieldName] = isValid;

  // Sekce je validní pouze pokud jsou VŠECHNA registrovaná pole true
  isFormValid.value = Object.values(fieldStatus.value).every(status => status === true);
};

const saveFinalInvoice = () => {
  emit('invoiceSaved', finalInvoice);
  emit('update:isVisible', false)
}

const handleModalStatus = (event) => {
  if (props.isVisible && event === 'closed') {
    emit('update:isVisible', false)
  }
}

</script>

<style scoped>
.form-label {
  font-weight: 500;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}
</style>